module.exports = __webpack_public_path__ + "static/media/ProjectTemplate.8a3cf43b.zip";